/**
 * "5m ago" / "in 2h" style formatting. ISO date in, human string out.
 *
 * Format is deliberately compact for table rows. Returns the input untouched
 * if it can't be parsed so we never render the literal string "Invalid Date".
 */
export function relativeTime(iso: string | null | undefined, now: Date = new Date()): string {
  if (!iso) return "—";
  const then = new Date(iso);
  const ms = then.getTime();
  if (Number.isNaN(ms)) return iso;
  const deltaSec = Math.round((ms - now.getTime()) / 1000);
  const abs = Math.abs(deltaSec);
  const past = deltaSec < 0;

  if (abs < 45) return past ? "just now" : "in a moment";
  if (abs < 90) return past ? "1m ago" : "in 1m";
  if (abs < 60 * 60) {
    const m = Math.round(abs / 60);
    return past ? `${m}m ago` : `in ${m}m`;
  }
  if (abs < 60 * 60 * 24) {
    const h = Math.round(abs / 3600);
    return past ? `${h}h ago` : `in ${h}h`;
  }
  if (abs < 60 * 60 * 24 * 7) {
    const d = Math.round(abs / 86400);
    return past ? `${d}d ago` : `in ${d}d`;
  }
  return then.toLocaleDateString();
}
